
/*
  This file is auto-generated by generate-icon-components.js. Do not edit it manually.
*/
import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

export const FhiIconTriangleAlertSelector = "fhi-icon-triangle-alert";

/**
 * ## FhiIconTriangleAlert
 * 
 * {@link https://designsystem.fhi.no/?path=/docs/ikoner--docs}
 * 
 * @tag fhi-icon-triangle-alert
 * @element fhi-icon-triangle-alert
 */
@customElement(FhiIconTriangleAlertSelector)
export class FhiIconTriangleAlert extends LitElement {

  /**
   * Sets the color for the icon.
   * Should preferably be a color token. See [Color Tokens](https://designsystem.fhi.no/?path=/docs/design-tokens-farger--docs)
   * @type {string}
   */ 
  @property({ type: String }) color: string = "currentcolor";

  /**
   * Sets the size of the icon. Can be one of the predefined sizes, a number value, rem or px.
   * Number values are treated as px.
   * @type { 'xsmall' | 'small' | 'medium' | 'large' | number | string}
   */
  @property({ type: String }) size: 'xsmall' | 'small' | 'medium' | 'large' | number | `${number}px` | `${number}rem` = 'medium';

  private get _size(): string {
    switch (this.size) {
      case 'xsmall': 
        return '1rem'; 
      case 'small':
        return '1.25rem';
      case 'medium':
        return '1.5rem'; 
      case 'large':
        return '2rem'; 
      default:
        if (String(this.size).endsWith('px') || String(this.size).endsWith('rem')) {
          return String(this.size);
        }
        if (isNaN(Number(this.size))) {
          console.warn(`Invalid size value: ${this.size}. Falling back to default size '1.5rem'.`)
          return '1.5rem';
        }
        return `${this.size}px`;
    }
  }

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${this._size}" height="${this._size}" fill="${this.color}"><path d="M12.008 2.25a2.75 2.75 0 0 1 2.39 1.392l8 13.997a2.752 2.752 0 0 1-2.38 4.125h-16v-.001A2.75 2.75 0 0 1 1.25 19.02a2.75 2.75 0 0 1 .368-1.381h.001L9.617 3.642a2.75 2.75 0 0 1 2.39-1.392m0 1.5a1.25 1.25 0 0 0-1.087.634l-.002.002-8 14-.001.003a1.251 1.251 0 0 0 1.094 1.875h16.006l.163-.011a1.25 1.25 0 0 0 .918-1.864l-.002-.003-8-14-.001-.002a1.25 1.25 0 0 0-1.088-.634M12.01 16a1 1 0 1 1 0 2H12a1 1 0 1 1 0-2zM12 8.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75"/></svg>
    `;
  }
      
  static styles = css`
    :host {
      display: flex;
      max-height: min-content;
      max-width: min-content;
    }
  `;
  }
